import { apiConfig } from '../apiConfig';
import { addCommonHeaders, handleResponse, handleErrors } from '../apiUtils';

export default {

    create: async ({ user_id, note, handleRedirect = null }) => {
        const url = apiConfig.apiUrl + "company_user_notes/";

        const body = JSON.stringify({
            company_user_note: {
                user_id: user_id,
                note: note,
            }
        });

        try {
            const response = await fetch(url, {
                method: "POST",
                headers: addCommonHeaders(),
                credentials: 'include',
                body: body
            })

            return await handleResponse(response, handleRedirect);

        } catch (error) {
            return handleErrors(error);
        }
    },

    update: async ({ note_id, note, handleRedirect = null }) => {
        const url = apiConfig.apiUrl + "company_user_notes/" + note_id;

        const body = JSON.stringify({
            company_user_note: {
                note: note,
            }
        });

        try {
            const response = await fetch(url, {
                method: "PATCH",
                headers: addCommonHeaders(),
                credentials: 'include',
                body: body
            })

            return await handleResponse(response, handleRedirect);

        } catch (error) {
            return handleErrors(error);
        }
    },

    // create: async (missionId, handleRedirect = null) => {
    //     const url = apiConfig.apiUrl + "missions/";

    //     const body = JSON.stringify({
    //         mission: {
    //             name,
    //         }
    //     });

    //     try {
    //         const response = await fetch(url, {
    //             method: "POST",
    //             body: body,
    //             headers: addCommonHeaders(),
    //             credentials: 'include',
    //         })

    //         return await handleResponse(response, handleRedirect);

    //     } catch (error) {
    //         return handleErrors(error);
    //     }
    // },

}